import { sanitizeConfigValue } from '../utils/sanitizeConfigValue';

const envValue = (name) => sanitizeConfigValue(process.env[name]);

const isPreviewAuthBypassEnabled =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_TRONA_PREVIEW_AUTH_BYPASS === 'true';

const previewAuth0Domain = isPreviewAuthBypassEnabled
  ? 'preview.tronallc.local'
  : undefined;
const previewAuth0ClientId = isPreviewAuthBypassEnabled
  ? 'trona-preview-client'
  : undefined;

const config = {
  development: {
    API_URL: envValue('REACT_APP_API_URL_DEV') || 'http://localhost:8080',
    API_BASE_URL:
      envValue('REACT_APP_API_URL_DEV') || 'http://localhost:8080',
    api: {
      baseURL: envValue('REACT_APP_API_URL_DEV') || 'http://localhost:8080',
    },
    apiUrl: envValue('REACT_APP_API_URL_DEV') || 'http://localhost:8080',
    auth0: {
      domain: envValue('REACT_APP_AUTH0_DOMAIN') || previewAuth0Domain,
      clientId:
        envValue('REACT_APP_AUTH0_CLIENT_ID') || previewAuth0ClientId,
      redirectUri:
        envValue('REACT_APP_AUTH0_REDIRECT_URI') || 'http://localhost:3000',
      audience: envValue('REACT_APP_AUTH0_AUDIENCE') || 'api.tronallc.com',
    },
    stripe: {
      publicKey: envValue('REACT_APP_STRIPE_PUBLIC_KEY'),
    },
  },
  staging: {
    API_URL: 'https://api-dev.tronallc.com',
    API_BASE_URL: 'https://api-dev.tronallc.com',
    api: {
      baseURL: 'https://api-dev.tronallc.com',
    },
    apiUrl: 'https://api-dev.tronallc.com',
    auth0: {
      domain: envValue('REACT_APP_AUTH0_DOMAIN'),
      clientId: envValue('REACT_APP_AUTH0_CLIENT_ID'),
      redirectUri: 'https://app-dev.tronallc.com',
      audience: envValue('REACT_APP_AUTH0_AUDIENCE') || 'api.tronallc.com',
    },
    stripe: {
      publicKey: envValue('REACT_APP_STRIPE_PUBLIC_KEY'),
    },
  },
  production: {
    API_URL: envValue('REACT_APP_API_URL_PROD') || 'https://api.tronallc.com',
    API_BASE_URL:
      envValue('REACT_APP_API_URL_PROD') || 'https://api.tronallc.com',
    api: {
      baseURL:
        envValue('REACT_APP_API_URL_PROD') || 'https://api.tronallc.com',
    },
    apiUrl: envValue('REACT_APP_API_URL_PROD') || 'https://api.tronallc.com',
    auth0: {
      domain: envValue('REACT_APP_AUTH0_DOMAIN'),
      clientId: envValue('REACT_APP_AUTH0_CLIENT_ID'),
      redirectUri:
        envValue('REACT_APP_AUTH0_REDIRECT_URI') ||
        'https://app.tronallc.com',
      audience: envValue('REACT_APP_AUTH0_AUDIENCE') || 'api.tronallc.com',
    },
    stripe: {
      publicKey:
        envValue('REACT_APP_STRIPE_PUBLIC_KEY_LIVE') ||
        envValue('REACT_APP_STRIPE_PUBLIC_KEY'),
    },
  },
};

// Detect environment based on hostname at runtime
const getEnvironment = () => {
  // Check if we're in a browser
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Dev/staging environment
    if (hostname === 'app-dev.tronallc.com' || hostname.includes('app-dev')) {
      return 'staging';
    }

    // Production
    if (hostname === 'app.tronallc.com') {
      return 'production';
    }

    // Cloudflare Pages preview deployments
    if (hostname.endsWith('.pages.dev')) {
      return 'staging';
    }
  }

  // Fallback to NODE_ENV
  return process.env.NODE_ENV || 'development';
};

const environment = getEnvironment();

const environmentConfig = {
  ...config[environment],
};

export default environmentConfig;
